// extracted by mini-css-extract-plugin
module.exports = {"root":"_0eb9cf14","isVariantPrimary":"_5a02d8bf","isVariantSecondary":"_c21d4362","prefix":"_99909ee3","input":"_d20667d5"};